import useAsyncData from 'src/utils/useAsyncData';
import { getMerchantsAPI, refreshMerchantsFromOpkcAPI } from 'src/serverApi/merchants';

const fetchFn = (fetchType: 'getMerchants' | 'refreshFromOpkc', ...params: any[]) => {
  const fn: (...params: any[]) => Promise<any> =
    fetchType === 'refreshFromOpkc' ? refreshMerchantsFromOpkcAPI : getMerchantsAPI;

  return fn(...params);
};

const useMerchants = () => {
  const [
    fetchMerchants,
    wasMerchantsFetched,
    isMerchantsLoading,
    merchants,
    merchantsError,
  ] = useAsyncData(fetchFn);

  return {
    fetchMerchants,
    wasMerchantsFetched,
    isMerchantsLoading,
    merchants,
    merchantsError,
  };
};

export default useMerchants;
